angular.module('policyModule')
  .service('policy', [function () {
      this.districtAdmin = {
          district: {
              show: true,
              edit: true,
              create: true,
              grades: true,
              schools: true,
              settings: true,
              performance: true,
              customers_usage: true,
          },
          grade: {
              show: true,
              edit: true,
              schools: true,
              teachers: true,
              settings: true
          },
          school: {
              show: true,
              edit: true,
              grades: true,
              teachers: true,
              settings: true,
              bulk_move_copy: true,
              bulk_upload: true,
              create: true,
              school_customers_usage: true
          },
          teacher: {
              show: true,
              edit: true,
              classes: true,
              settings: true,
              students: true
          },
          classroom: {
              show: true,
              edit: true,
              assign: true,
              activity: true,
              alerts: true,
              roster: true,
              roster_ro: true,
              settings: true,
              engagement_restrictions: true,
              password_type: true,
              standards: true,
              overview: true,
              usage: true,
              performance: true,
              assignments: true,
              primary_graduation: true,
              concepts: true
          },
          guardian: {
              show: false,
              edit: false,
              activity: false,
              assign: false,
              overview: false,
              standards: false,
              usage: false,
              assignments: false,
              create_assignment: false,
              create_nwea_assignment: false,
              create_quantile_assignment: false
          },
          student: {
              show: true,
              edit: true,
              assign: true,
              activity: true,
              overview: true,
              standards: true,
              settings: true,
              password: true,
              usage: true,
              assignments: true,
              concepts: true
          }
      };

      this.schoolAdmin = {
          district: {
              show: false,
              edit: false,
              grades: false,
              schools: false,
              settings: false,
              performance: false,
              customers_usage: false,
          },
          grade: {
              show: true,
              edit: true,
              schools: true,
              teachers: true,
              settings: true
          },
          school: {
              show: true,
              edit: true,
              grades: true,
              teachers: true,
              settings: true,
              bulk_move_copy: true,
              bulk_upload: true,
              create: true,
              school_customers_usage: true
          },
          teacher: {
              show: true,
              edit: true,
              classes: true,
              settings: true,
              students: true
          },
          classroom: {
              show: true,
              edit: true,
              assign: true,
              activity: true,
              alerts: true,
              roster: true,
              roster_ro: true,
              settings: true,
              engagement_restrictions: true,
              password_type: true,
              standards: true,
              overview: true,
              usage: true,
              performance: true,
              assignments: true,
              primary_graduation: true
          },
          guardian: {
              show: false,
              edit: false,
              activity: false,
              assign: false,
              overview: false,
              standards: false,
              usage: false,
              assignments: false,
              create_assignment: false,
              create_nwea_assignment: false,
              create_quantile_assignment: false
          },
          student: {
              show: true,
              edit: true,
              assign: true,
              activity: true,
              overview: true,
              standards: true,
              settings: true,
              password: true,
              usage: true,
              assignments: true,
        }
      };

      this.teacher = {
          district: {
              show: false,
              edit: false,
              grades: false,
              schools: false,
              settings: false,
              performance: false,
              customers_usage: false,
          },
          grade: {
              show: false,
              edit: false,
              schools: false,
              teachers: false,
              settings: false
          },
          school: {
              show: false,
              edit: false,
              grades: false,
              teachers: false,
              settings: false,
              school_customers_usage: false
          },
          teacher: {
              show: true,
              edit: true,
              classes: true,
              settings: true,
              students: true
          },
          classroom: {
              show: true,
              edit: true,
              assign: true,
              activity: true,
              alerts: true,
              roster: true,
              roster_ro: true,
              settings: true,
              engagement_restrictions: true,
              password_type: true,
              standards: true,
              overview: true,
              usage: true,
              performance: true,
              assignments: true,
              primary_graduation: true,
              concepts: true
          },
          guardian: {
              show: false,
              edit: false,
              activity: false,
              assign: false,
              overview: false,
              standards: false,
              usage: false,
              assignments: false,
              create_assignment: false,
              create_nwea_assignment: false,
              create_quantile_assignment: false
          },
          student: {
              show: true,
              edit: true,
              assign: true,
              activity: true,
              overview: true,
              standards: true,
              settings: true,
              password: true,
              usage: true,
              assignments: true,
              create_assignment: true,
              create_nwea_assignment: true,
              create_quantile_assignment: true,
              concepts: true
          }
      };

      this.guardian = {
          district: {
              show: false,
              edit: false,
              grades: false,
              schools: false,
              settings: false,
              performance: false,
              customers_usage: false,
          },
          grade: {
              show: false,
              edit: false,
              schools: false,
              teachers: false,
              settings: false
          },
          school: {
              show: false,
              edit: false,
              grades: false,
              teachers: false,
              settings: false,
              school_customers_usage: true
          },
          teacher: {
              show: false,
              edit: false,
              classes: false,
              settings: false,
              students: false
          },
          classroom: {
              show: false,
              edit: false,
              assign: false,
              activity: false,
              roster: false,
              roster_ro: false,
              settings: false,
              engagement_restrictions: false,
              password_type: false,
              standards: false,
              overview: false,
              usage: false,
              performance: false
          },
          guardian: {
              show: true,
              edit: false,
              activity: true,
              assign: true,
              overview: true,
              standards: true,
              usage: true,
              assignments: true,
              create_assignment: true,
              create_nwea_assignment: false,
              create_quantile_assignment: false
          },
          student: {
              show: true,
              edit: false,
              assign: false,
              activity: true,
              overview: false,
              overview_old: false,
              standards: false,
              settings: false,
              password: false,
              usage: true
          }
      };
  }]);
